import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import config from '../envConfig';
import { limparDadosFamilia } from '../features/ConsultaSimples/consultaSimplesSlice';
import { resetIdentificacaoPositiva } from '../features/IdentificacaoPositiva/identificacaoPositivaSlice';
import { limparPerfil } from '../features/Perfil/perfilSlice';
import { resetTermoDeUso } from '../features/TermoDeUso/termoDeUsoSlice';
import { setLoading, setLoggingOut } from '../globalSlice';
import auth from './Auth';
import authIdPositiva from './AuthIdPositiva';
import { limpar } from '../features/Suporte/SuporteSlice';
import { setMostrarModalPendencias } from '../features/ConsultaPendencias/consultaPendenciasSlice';
import { limparLastApiCallTime } from '../features/CaixaMensagem/CaixaMensagemSlice';
import http from '../common/http';
import env from './../envConfig';
export interface AuthState {
  govBr: {
    logado: boolean;
    redirectTo: string;
  };
  gateway: {
    logado: boolean;
    redirectTo: string;
  };
}

const initialState: AuthState = {
  govBr: {
    logado:  auth.isAuthenticated(),
    redirectTo: '/home',
  },
  gateway: {
    logado:  auth.isAuthenticated(),
    redirectTo: '/home',
  }
};

export const authLogout = createAsyncThunk('auth/authLogout', async (params: any, { dispatch }) => {
  if (auth.isAuthenticated()) {
    dispatch(setLoggingOut(true));
    dispatch(limparPerfil());
    dispatch(limparDadosFamilia());
    dispatch(resetTermoDeUso());
    dispatch(setMostrarModalPendencias(true));
    dispatch(limpar());
    auth.limparStorage();

    try {
      const responseGateway = await http.post(env.gateway.logoutUrl);
      const redirectUrl = responseGateway.headers['location'];

      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        console.log("response", JSON.stringify(responseGateway))

        window.location.replace("#/home")
        window.location.reload();
      }
    } catch (error) {
      window.location.replace("#/home")
      window.location.reload();
    }
  }
});



/*export const authLogout = createAsyncThunk('auth/authLogout', async (params: any, { dispatch }) => {
  if (auth.isAuthenticated()) {
    dispatch(setLoggingOut(true));
    try {
        // Limpar todos os estados Redux
        dispatch(limparPerfil());
        dispatch(limparDadosFamilia());
        dispatch(resetTermoDeUso());
        dispatch(resetIdentificacaoPositiva());
        dispatch(setMostrarModalPendencias(true));
        dispatch(limpar());
        dispatch(limparLastApiCallTime());

        // Limpar estados de autenticação
        dispatch(setGatewayLogado(false));
        dispatch(setGovBrLogado(false));
        dispatch(limparAuth());

        // Limpar storage
        auth.limparStorage();
        auth.logoutGovBr();
    } finally {
        dispatch(setLoggingOut(false));
    }
  }
});
*/

export const authLimparDadosFamilia= createAsyncThunk('auth/authLimparDadosFamilia', async (params: any, { dispatch }) => {
  dispatch(limparPerfil());
  dispatch(limparDadosFamilia());
});

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginGateway: (state, action) => {
      state.gateway.redirectTo = action.payload ? action.payload : initialState.gateway.redirectTo;
      auth.login();
    },
    limparAuth: (state) => {
      state.gateway.logado = false;
      state.gateway.redirectTo = initialState.gateway.redirectTo;
    },
    setGovBrLogado: (state, action) => {
      state.govBr.logado = action.payload;
    },
    setGatewayLogado: (state, action) => {
      state.gateway.logado = action.payload;
    }
  },
});

export const { loginGateway, limparAuth, setGovBrLogado, setGatewayLogado } = authSlice.actions;

export const selectGovBr = (state: RootState) => state.auth.govBr;
export const selectGateway = (state: RootState) => state.auth.gateway;

export default authSlice.reducer;
